import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { PaymentMethodMasterDropDown, Response } from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodMasterService {
  private api: string = CONTROLLERS.PAYMENTMETHODMASTER;
  constructor(private apiService: ApiService) { }

  getPaymentMethodDropdown(): Observable<Response<PaymentMethodMasterDropDown>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.PAYMENTMETHODMASTER.GET_PAYMENT_METHOD_MASTER_DROPDOWN}`
    );
  }
}
